// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"b6000ac5","140":"5c029fdb"}[chunkId] + ".chunk.css";
};